import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { TaskDetailsComponent } from './task-details/task-details.component';
import { TransitionBarComponent } from './transition-bar/transition-bar.component';
import { InfrastructureModule } from '../../../../../infra/infrastructure.module';
import { McbGridModule } from '../../../../../infra/components/grid/mcb-grid.module';

@NgModule({
    declarations: [
        DashboardComponent,
        TaskDetailsComponent,
        TransitionBarComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        InfrastructureModule,
        McbGridModule,
        DashboardRoutingModule
    ],
    providers: [
    ]
})
export class DashboardModule {
}
